"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slateToDom = void 0;
var domhandler_1 = require("domhandler");
var default_1 = require("./config/default");
var convert_slate_1 = require("./utilities/convert-slate");
var slateToDom = function slateToDom(node) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : default_1.config;
  if (!Array.isArray(node)) {
    return new domhandler_1.Document([]);
  }
  var document = node.map(function (n, index) {
    return (0, convert_slate_1.convertSlate)({
      node: n,
      config: config,
      isLastNodeInDocument: index === node.length - 1
    });
  });
  return document;
};
exports.slateToDom = slateToDom;